import { Controller } from '@hotwired/stimulus';

import GridyCommon from '@/modules/gridy_common';
import I18n from '@/modules/i18n';
import ModuleLoader from '@/modules/module_loader';
import TemplatesCommon from '@/pages/common/templates';
import TemplatesEvents from '@/pages/events/templates';

export default class extends Controller {
  connect() {
    this.dataDiscount = document.querySelector('[data-discount]');
    this.dataTax = document.querySelector('[data-tax]');
    this.dataTotal = document.querySelector('[data-total]');
    this.dataProfit = document.querySelector('[data-profit]');
    this.grid = $('[data-gridy]');
    this.options = ModuleLoader.getOptions();
    this.paymentMethodField = document.querySelector('[data-payment-method]');
    this.progressBars = document.querySelector('[data-progress-bars]');

    this.gridy();
    this.bindFilters();
  }

  animateProgressBars({ discount, profit, status, tax, total_paid }) {
    let html = '';

    for (const item of status) {
      const percentage = item.percentage > 100 ? 100 : item.percentage;

      html += TemplatesCommon.progress_bar({ ...item, percentage });
    }

    this.dataDiscount.innerText = discount;
    this.dataProfit.innerText = profit;
    this.dataTax.innerText = tax;
    this.dataTotal.innerText = total_paid;
    this.progressBars.innerHTML = html;
  }

  bindFilters() {
    this.paymentMethodField.addEventListener('change', () => {
      this.grid.gridy('refresh');
    });
  }

  gridy() {
    GridyCommon.gridy(this.grid, {
      done: (json) => {
        this.animateProgressBars(json);
      },

      find: 'users.name',
      paramsElements: ['[data-payment-method]'],
      sortName: 'paid_at',
      sortOrder: 'desc',
      template: TemplatesEvents.events.gridy_invoices,
      url: this.options.gridy.url,

      headers: [
        { name: I18n.t('id'), value: '' },
        { name: I18n.t('name'), value: 'customer_name' },
        { name: I18n.t('activerecord.attributes.user.email'), value: 'customer_email' },
        { name: I18n.t('payment_method.short'), value: 'payment_method' },
        { name: I18n.t('paid_at'), value: 'paid_at' },
        { name: I18n.t('total'), value: 'total_paid_cents' },
        { name: I18n.t('activerecord.models.tax.one'), value: 'tax_cents' },
        { name: I18n.t('discount.one'), value: 'discount_cents' },
        { name: I18n.t('liquid'), value: 'total_liquid_cents' },
        { name: I18n.t('action.other'), value: '' },
      ],
    });
  }

  onRefund() {
    this.grid.gridy('refresh');
  }
}
